import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IHvDaten } from '../../models/hvdaten';
import { PopupService } from '../../service/popup.service';

@Component({
  selector: 'app-gebaeude-hochwasserzone',
  templateUrl: './gebaeude-hochwasserzone.component.html',
  styleUrls: ['./gebaeude-hochwasserzone.component.scss']
})
export class GebaeudeHochwasserzoneComponent implements OnInit {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  @Output()
  calculateRatePendingEvent = new EventEmitter<void>();

  @Output()
  loadHvPaketePendingEvent = new EventEmitter<void>();

  constructor(public translateService: TranslateService, public popupService: PopupService) { }

  static createFormGroup(fb: UntypedFormBuilder) {
    return fb.group({
      gebaeudeHochwasserzone: new UntypedFormControl('', [Validators.required])
    });
  }

  ngOnInit(): void {
    this.onValueChanged();
  }

  get gebaeudeHochwasserzone() { return this.formGroup.get('gebaeudeHochwasserzone'); }

  onValueChanged(): void {
    this.gebaeudeHochwasserzone.valueChanges.subscribe(() => {
      this.calculateRatePendingEvent.emit();
      this.loadHvPaketePendingEvent.emit();
    });
  }

  getGebaeudeHochwasserzone(): IHvDaten {
    return {
      GebaeudeHochwasserzone: this.gebaeudeHochwasserzone.value === 'ja' ? true : false
    } as IHvDaten;
  }

  setGebaeudeHochwasserzone(daten: IHvDaten) {
    this.gebaeudeHochwasserzone.setValue(daten.GebaeudeHochwasserzone? 'ja': 'nein');
  }
}
